import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import cn from 'classnames';
import { CloseCross } from '../../icons';
import { useBiAction } from '../BiTracking';
import { IconButton } from '../IconButton';
import classes from './CloseButton.module.scss';
export function CloseButton(props) {
    const { className, skin, size = 'small', disabled, bi, noBi: _noBi, onClick, testId, icon } = props, rest = _object_without_properties(props, [
        "className",
        "skin",
        "size",
        "disabled",
        "bi",
        "noBi",
        "onClick",
        "testId",
        "icon"
    ]);
    const logBiAction = useBiAction();
    const handleClick = useCallback((e)=>{
        if (bi === null || bi === void 0 ? void 0 : bi.name) {
            logBiAction({
                entityType: 'close_button',
                entityName: bi.name,
                actionType: 'close',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    test_id: testId !== null && testId !== void 0 ? testId : ''
                })
            });
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [
        bi,
        logBiAction,
        onClick,
        testId
    ]);
    const sizeIconMap = {
        xsmall: /*#__PURE__*/ _jsx(CloseCross, {
            size: 8
        }),
        small: /*#__PURE__*/ _jsx(CloseCross, {
            size: 16
        }),
        medium: /*#__PURE__*/ _jsx(CloseCross, {
            size: 24
        })
    };
    return /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({
        // eslint-disable-next-line custom/no-hardcoded-nobi-in-seagull -- CloseButton self-logs its own `close` BI event; inner IconButton bi would double-fire
        noBi: true,
        className: cn(classes.root, className),
        noPadding: true,
        skin: skin,
        size: size,
        disabled: disabled,
        type: "button",
        onClick: handleClick,
        testId: testId
    }, rest), {
        children: icon !== null && icon !== void 0 ? icon : sizeIconMap[size]
    }));
}
